export default "__VITE_ASSET__ooJ6$pfh__"